import styled from "@emotion/styled"
import { cssVars } from "components/nav-v2/Wrapper"
import ShareButton from "components/share/ShareButton"
import getMediaQuery from "css/breakpoints"
//import { useLocation } from "react-router-dom"

const Root = styled(ShareButton)`
  display: grid;
  justify-content: end;
  pointer-events: none;

  button {
    --distance-from-start: 2rem;
    ${getMediaQuery("m")} {
      --distance-from-start: calc(100dvh - (var(${cssVars.main.safe}) * 2) + 9px);
    }

    margin-block: var(--distance-from-start) 2rem;
    margin-inline-end: var(--outer-margin);
    pointer-events: auto;
    position: sticky;
    top: calc(100dvh - 1.38rem - 2.1875rem * 1.25);
    z-index: 9999;
  }
`

export default function Share(props) {
  // const location = useLocation()
  // if (!location.state?.prevUrl.includes("/rolex-family") && !location.state?.prevUrl.includes("/rolex-event")) return null
  return <Root {...props} />
}
